import { z } from 'zod';
import { zPrintJobStatus } from '../enums';
import { docketSchema } from './docketSchema';

export const printJobSchema = z.object({
  createdByPosTerminalUuid: z.string().nullable().default(null), // TODO: Remove (Not set in new POS v9+)
  dockets: z.array(docketSchema).default([]),
  hasFailedDockets: z.boolean().default(false),
  /** `_id` of the iPad that created this print job (device-auth build). */
  iPadId: z.string().nullable().default(null).optional(), // optional() for API backwards compatibility.
  localCreatedAt: z.number(),
  localUpdatedAt: z.number(),
  order: z.string().nullable().default(null),
  orderUuid: z.string().nullable().default(null),
  processedAt: z.number().nullable().default(null),
  processingError: z.string().nullable().default(null),
  restaurantId: z.string(),
  status: zPrintJobStatus.default('QUEUED_FOR_PROCESSING'),
  uuid: z.string(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type PrintJob = z.output<typeof printJobSchema>;

export const printJobStrictSchema = printJobSchema.safeExtend({
  createdByPosTerminalUuid: z.guid().nullable(), // TODO: Remove (Not set in new POS v9+)
  orderUuid: z.guid().nullable(),
  uuid: z.guid(),
});

export const printJobCvxSchema = printJobSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
});
export type PrintJobCvx = z.output<typeof printJobCvxSchema>;
